<template>
    <div class="r-topic" >
      <slot></slot>
    </div>
  </template>
  
  <script type="text/javascript">
  import $ from 'jquery'
  export default {
    name: 'topic',
    props: {
      topicId: [String, Number],
      gameId: [String, Number],
      userId: [String, Number],
      replyId: [String, Number],
      row: [Object,Array]
    },
    computed: {
  
    }
  }
  </script>
  <style lang="less" scoped>
    .r-topic {
        padding: 0.6rem 0;
    }
  </style>
  